import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import modal from './modules/modal'
import auth from './modules/auth'
import tagsView from './modules/tagsView'
import relatorio from './modules/relatorio/'

const modules = {
  modal,
  auth,
  relatorio,
  tagsView
}

Vue.use(Vuex)
export default new Vuex.Store({
  modules
})
